import React, { type HTMLAttributes } from 'react';

import { Container, Text } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ButtonWrapper } from '../../../components';
import type { ParagraphText as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphText: React.FC<ParagraphTextProps> = ({
  id,
  entity,
}) => {
  const paragraphText = entity.toJS();
  const title = paragraphText.field_title[0]?.value;
  const body = paragraphText.field_body[0].processed || '';

  // Check if we have a readMore section
  const [, introText, readMore] = body.match(/^(.*)(<div class="ckeditor-readmore-wrapper">.*)/) || [];

  const link = paragraphText.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const secondaryLink = paragraphText.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;

  return (
    <div id={id} className="Paragraph ParagraphText">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Text
              title={title}
              text={introText || body}
              readMore={readMore}
              readMoreHeight={60}
            />

            {(linkUrl || secondaryLinkUrl) && (
              <div className="ParagraphText__links">
                {linkUrl && (
                  <ButtonWrapper
                    href={linkUrl}
                  >
                    {linkTitle}
                  </ButtonWrapper>
                )}

                {secondaryLinkUrl && (
                  <ButtonWrapper
                    type="secondary"
                    href={secondaryLinkUrl}
                  >
                    {secondaryLinkTitle}
                  </ButtonWrapper>
                )}
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphText;
